export const colorPartido = (nomenclator, codpar) => {
	return nomenclator.partidos[Number(codpar) -1].color
};